import React, {FC, Fragment, RefObject, useEffect, useRef, useState} from "react";
import {IAtributeOptions, IAttributeValue} from "../../../types/widgetFiltresTypes";
import cls from "./category.module.scss";
import {ArrowRoundedDown12x7Svg, Check9x7Svg} from "../../../svg";
import {useSelector} from "react-redux";
import {IState} from "../../../types/state";
import {useRouter} from "next/router";
import {handleFilterChange} from "./helpers";

interface IFilterCheckProps {
    data: Array<IAtributeOptions>,
    title: string
    value: IAttributeValue
}

const ListItemLabel:FC<{ item: IAtributeOptions, checked: boolean, code: string }> =
    ({ item, checked, code }) => {
        const router = useRouter();
        const itemDisabledCls: string = (() => {
            if (!item.count) return "";
            return cls["filter-list__item--disabled"]
        })()
        const isCheckedItem: string = (() => {
            if (!checked) return "";
            return cls.checked
        })()
        return (
            <label className={`${cls["filter-list__item"]} ${cls.checkbox__item} ${itemDisabledCls}`}>
                <div className={`${cls["filter-list__input"]} ${cls["input-check"]}`}>
                    <span className={cls["input-check__body"]}>
                        <input
                            className={cls["input-check__input"]}
                            type="checkbox"
                            value={item.id}
                            checked={checked}
                            disabled={item.count === 0}
                            onChange={(e) => handleFilterChange(e, router, code)}
                        />
                        <span className={cls["input-check__box"]}/>
                        <Check9x7Svg className={cls["input-check__icon"]}/>
                    </span>
                    <span
                        className={`${cls["filter-list__title"]} ${isCheckedItem}`}>
                    {item.label}
                </span>
                </div>
            </label>
        )
    }

const CustomFilterCheck: FC<IFilterCheckProps> = ({data = [], value, title}) => {
    const {attributes: [{code = ""} = {}] = []} = value || {}
    const sidebarOpen = useSelector((state: IState) => state.sidebar.open)
    const [filterListHeight, setFilterListHeight] = useState<boolean>(false);
    const checkRef: RefObject<HTMLDivElement> = useRef<HTMLDivElement>(null);
    const router = useRouter();
    const isOpen = (router.query?.open_dd as string)?.split(",")?.some(ii => ii === title) || false
    useEffect(() => {
        if (!filterListHeight && checkRef.current?.clientHeight) {
            setFilterListHeight(checkRef.current?.clientHeight > 88)
        }
    }, [checkRef.current?.clientHeight, sidebarOpen])

    const toggleOpen = async () => {
        if ((router.query?.open_dd as string)?.split(",")?.some(elem => elem === title)) {
            const queryObj = router.query || {};
            if ((queryObj.open_dd as string)?.split(',').length === 1) {
                delete queryObj.open_dd;
            } else {
                queryObj.open_dd = (queryObj.open_dd as string)?.split(',').filter(item => item !== title).join(",")
            }
            await router.push({query: queryObj}, undefined, {scroll: false})
        } else {
            let existTitlesDD = [title]
            if (router.query?.open_dd) {
                existTitlesDD = [...(router.query?.open_dd as string).split(","), title];
            }
            await router.push({query: {...router.query, open_dd: existTitlesDD.join(",")}}, undefined, {scroll: false})
        }
    };

    return (
        <div className={`${cls["filter-list"]} ${!isOpen && filterListHeight ? cls["filter-list__closed"] : ""}`} ref={checkRef}>
            <div className={cls.widget__title}
                 onClick={toggleOpen}
            >
                {title}
                {filterListHeight && (
                    <button
                        className={`${cls.filter__item} ${isOpen && cls.open}`}
                        type="button"
                    >
                        <ArrowRoundedDown12x7Svg className={cls["mobile-links__item-arrow"]}/>
                    </button>
                )}
            </div>
            <div className={cls["filter-list__list"]}>
                {data?.map((item, index: number) => {
                    const checked = String(router.query?.[`filter_${code}`]).split(",")
                        .some(elem => elem ===  String(item.id))
                    return <ListItemLabel
                        key={index}
                        checked={checked}
                        code={code}
                        item={item}
                    />;
                })}
            </div>
        </div>
    );
}

export default CustomFilterCheck;